'use strict';

import { getCookie, deleteCookie } from '@jspartials/cookie-utils';

// Cookie names
const COOKIE_NAME_FOR_PICK_UP_POINT_PREFERRED = 'pickUpPointPreferred';

// Selectors
const CHECKOUT_WRAPPER_SELECTOR = '.js-checkout-wrapper';

const getPickUpPointPreferredFromCookie = () => {
  const cookieValue = getCookie(COOKIE_NAME_FOR_PICK_UP_POINT_PREFERRED);

  if (!cookieValue) {
    return null;
  }

  try {
    return JSON.parse(decodeURIComponent(cookieValue));
  } catch (error) {
    return null;
  }
};

/**
 * External pick up points (isPickUpPoint: true) must only live while the user
 * stays inside the checkout. Any page rendered outside the checkout discards
 * the selection, so the user always has to choose a pick up point again.
 * Hawkers stores (isPickUpPoint: false) are always kept.
 */
const clearPickUpPointWhenOutsideCheckout = () => {
  const isCheckoutPage = Boolean(
    document.querySelector(CHECKOUT_WRAPPER_SELECTOR)
  );

  if (isCheckoutPage) {
    return;
  }

  const pickUpPointPreferred = getPickUpPointPreferredFromCookie();

  if (pickUpPointPreferred && pickUpPointPreferred.isPickUpPoint === true) {
    deleteCookie(COOKIE_NAME_FOR_PICK_UP_POINT_PREFERRED);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  clearPickUpPointWhenOutsideCheckout();
});

// Covers pages restored from the browser back/forward cache, where
// DOMContentLoaded does not fire again
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    clearPickUpPointWhenOutsideCheckout();
  }
});
